import { Tooltip } from '@mui/material';
import Label from '../../../components/label';
import { PendingAdjustmentSummary } from '../../../api/stock-adjustment.service';

type Props = {
  pending?: PendingAdjustmentSummary;
};

/** "Pending +10" badge next to a product's (approved) stock figure. */
export default function PendingStockLabel({ pending }: Props) {
  if (!pending || pending.count === 0) return null;
  const net = pending.netQty > 0 ? `+${pending.netQty}` : `${pending.netQty}`;
  return (
    <Tooltip
      title={`${pending.count} adjustment${
        pending.count === 1 ? '' : 's'
      } (net ${net}) waiting for manager approval on Stock → Adjustments. The stock shown does not include ${
        pending.count === 1 ? 'it' : 'them'
      } yet.`}
    >
      <span>
        <Label variant="soft" color="warning" sx={{ ml: 1 }}>
          Pending {net}
        </Label>
      </span>
    </Tooltip>
  );
}
